import * as actionsInterfaces from './types';
import { IAsyncAction } from '../types';
import * as actionsTypes from './constants';
import { IBusiness, IService, IBookingPayload, IBooking } from './types';

export const getBusinesses = (
    callback?: (result: any, error: any) => void,
): IAsyncAction => {
    return {
        type: actionsTypes.GET_BUSINESSES,
        callback
    };
};

export const storeBusinesses = (
    businesses: IBusiness[],
    callback?: (result: any, error: any) => void,
): actionsInterfaces.IBusinesssAction => {
    return {
        type: actionsTypes.STORE_BUSINESSES,
        businesses,
        callback
    };
};

// export const storeBusinessBookings = (
//     businesses: IBusiness[],
//     callback?: (result: any, error: any) => void,
// ): actionsInterfaces.IBusinesssAction => {
//     return {
//         type: actionsTypes.STORE_BUSINESSES,
//         businesses,
//         callback
//     };
// };

export const getBusinessBookings = (
    businessId: string,
    callback?: (result: any, error: any) => void,
): actionsInterfaces.IGetBusinessBookings => {
    return {
        type: actionsTypes.GET_BUSINESS_BOOKINGS,
        businessId,
        callback
    };
};

export const toggleSelectedBusinessService = (
    business: IBusiness,
    service: IService,
    callback?: (result: any, error: any) => void,
): actionsInterfaces.IToggleBusinessService => {
    return {
        type: actionsTypes.TOGGLE_SELECTED_BUSINESS_SERVICE,
        business,
        service,
        callback
    };
};

export const clearSelectedBusinessServices = (
    callback?: (result: any, error: any) => void,
): IAsyncAction => {
    return {
        type: actionsTypes.CLEAR_SELECTED_BUSINESS_SERVICES,
        callback
    };
};

export const createBooking = (
    payload: IBookingPayload,
    callback?: (result: any, error: any) => void,
): actionsInterfaces.ICreateBookingAction => {
    return {
        type: actionsTypes.CREATE_BOOKING,
        payload,
        callback
    };
};

export const getBusinessById = (
    businessId: string,
    callback?: (result: any, error: any) => void,
): actionsInterfaces.IGetBusinessById => {
    return {
        type: actionsTypes.GET_BUSINESS_BY_ID,
        businessId,
        callback
    };
};

export const storeSelectedBusiness = (
    business: IBusiness,
    bookings: IBooking[],
): actionsInterfaces.IStoreSelectedBusiness => {
    return {
        type: actionsTypes.STORE_SELECTED_BUSINESS,
        business,
        bookings
    };
};

